import UserOfficesApi from "@Front/Api/LeCoffreApi/Notary/UserOffices/UserOffices";
import { LoggerService } from "@Front/Services/LoggerService/LoggerService";

export type SetActiveOfficeApiSuccess = {
	office_uid: string;
	accessToken?: string;
	refreshToken?: string;
	message?: string;
};

function logSetActiveOfficeResponse(
	result: { office_uid?: string; accessToken?: string; refreshToken?: string; message?: string } | null,
	officeUid: string,
): void {
	LoggerService.info("🔍 setActiveOffice réponse backend reçue", {
		hasResult: !!result,
		resultType: typeof result,
		hasMessage: !!result?.message,
		hasOfficeUid: !!result?.office_uid,
		hasAccessToken: !!result?.accessToken,
		hasRefreshToken: !!result?.refreshToken,
		resultKeys: result ? Object.keys(result) : [],
		officeUid: result?.office_uid ?? officeUid,
	});
}

export async function invokeUserOfficesSetActive(
	userUid: string,
	officeUid: string,
	ensureApi: () => void,
	menuOfficeUidForGuestJwt?: string | null,
): Promise<SetActiveOfficeApiSuccess> {
	ensureApi();
	const raw = await UserOfficesApi.getInstance().setActiveOffice(userUid, officeUid, menuOfficeUidForGuestJwt);
	logSetActiveOfficeResponse(raw, officeUid);
	if (!raw || !raw.office_uid) {
		const errorMsg = !raw ? "La réponse du serveur est invalide" : "La réponse du serveur est incomplète (office_uid manquant)";
		LoggerService.error(`❌ setActiveOffice: ${errorMsg}`, { userUid, officeUid, result: raw });
		throw new Error(errorMsg);
	}
	return raw as SetActiveOfficeApiSuccess;
}
